import { EnrollmentAcceptedData } from '../dtos/customer';
import { ManualOverrideAcceptedData } from '../dtos/manualOverride';
import { RoomEntryState } from '../enums/roomEntryState';

/**
 * A restart acknowledgement the ACS sent back over the hub. `success: false` means the site
 * reported it could not act — no HMI configured, or no biometric device connected — which the
 * button surfaces as an error rather than a silent success.
 *
 * This is an object rather than a bare site id so restarting the same site twice still yields a
 * fresh reference and re-triggers the button's effect.
 */
export interface RestartAck {
    siteId: number;
    success: boolean;
}

export interface SignalRState {
    hubConnected: boolean;
    serviceStatus: Map<number, boolean>;
    alarmStatus: Map<number, boolean>;
    roomState: Map<number, { roomEntryState: RoomEntryState; customerName: string }>;
    sensorResetCompleted: number | undefined;
    systemRestartTriggered: number | undefined;
    serviceRestartTriggered: RestartAck | undefined;
    restartHmiDeviceCompleted: RestartAck | undefined;
    restartBiometricDeviceCompleted: RestartAck | undefined;
    enrollmentAcceptedData: EnrollmentAcceptedData | undefined;
    manualOverrideAcceptedData: ManualOverrideAcceptedData | undefined;
    maintenanceModeStatus: Map<number, { isEnabled: boolean; endTime?: Date }>;
    uiConnected: boolean;
}

export const initialState: SignalRState = {
    hubConnected: false,
    serviceStatus: new Map(),
    alarmStatus: new Map(),
    roomState: new Map(),
    sensorResetCompleted: undefined,
    systemRestartTriggered: undefined,
    serviceRestartTriggered: undefined,
    restartHmiDeviceCompleted: undefined,
    restartBiometricDeviceCompleted: undefined,
    enrollmentAcceptedData: undefined,
    manualOverrideAcceptedData: undefined,
    maintenanceModeStatus: new Map(),
    uiConnected: false,
};
